module.exports = __webpack_public_path__ + "static/media/Advertise.cafe913d.png";